import React from 'react';
import UtcDateTimeField from './UtcDateTimeField';
import CustomToolTip from '../../../../../CommonComponents/CustomToolTip';
import styles from './PropertyPanel.module.scss';

interface PropertyRowProps {
  label: string;
  value?: React.ReactNode;
  unit?: string;
  isLive?: boolean;
  isMixed?: boolean;
  readOnly?: boolean;
  inputType?: 'text' | 'number' | 'select' | 'datetime';
  selectOptions?: string[];
  onChange?: (value: string) => void;
  valueAlign?: 'left' | 'right';
  disabled?: boolean;
}

const PropertyRow: React.FC<PropertyRowProps> = ({
  label, value = '', unit, isLive, isMixed, readOnly, inputType, selectOptions, onChange, valueAlign, disabled = false,
}) => {
  const isDisabled = readOnly || disabled;
  return (
    <div className={styles.row}>
      <CustomToolTip title={label} placement="top-start" className={styles.rowLabel}>
        {label}
      </CustomToolTip>
      <div className={`${styles.rowValue} ${valueAlign === 'left' ? styles.rowValueLeft : ''}`}>
        {isLive ? (
          <span className={styles.liveValue}>{value}{unit && <span className={styles.unit}>{unit}</span>}</span>
        ) : inputType === 'select' ? (
          <div className={styles.inputWrap}>
            <select
              className={styles.input}
              value={value as any}
              onChange={e => onChange?.(e.target.value)}
              disabled={isDisabled}
            >
              {selectOptions?.map(opt => <option key={opt}>{opt}</option>)}
            </select>
          </div>
        ) : inputType === 'datetime' ? (
          <div className={styles.inputWrap}>
            <UtcDateTimeField
              value={value as any}
              onChange={(display) => onChange?.(display)}
              disabled={isDisabled}
            />
            {unit && <span className={styles.unitChip}>{unit}</span>}
          </div>
        ) : inputType ? (
          <div className={styles.inputWrap}>
            <input
              className={`${styles.input} ${isMixed ? styles.mixed : ''} ${isDisabled ? styles.readOnly : ''}`}
              type={inputType}
              value={value as any}
              readOnly={isDisabled}
              disabled={isDisabled}
              onChange={isDisabled ? undefined : e => onChange?.(e.target.value)}
              placeholder={isMixed ? '—' : undefined}
            />
            {unit && <span className={styles.unitChip}>{unit}</span>}
          </div>
        ) : (
          <span className={styles.staticValue}>{value}</span>
        )}
      </div>
    </div>
  );
};

export default PropertyRow;
